// PURE desktop dev keys (IMPLEMENTATION §2.7 "Mouse (desktop dev)", UX §1.6): B build, S shop, M Merge All,
// Ctrl/Cmd+Z undo, Esc cancel / close. Letters without modifiers only; auto-repeat is ignored; keys typed
// into a text field never act.

export type KeyAction = 'toggleBuild' | 'toggleShop' | 'mergeAll' | 'undo' | 'escape';

export interface KeyLike {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  altKey: boolean;
  shiftKey: boolean;
  repeat: boolean;
  /** The event targets an editable element (input, textarea, contenteditable). */
  editable: boolean;
}

export function keyAction(e: KeyLike): KeyAction | null {
  if (e.repeat || e.editable || e.altKey) return null;
  const k = e.key.toLowerCase();
  if (k === 'escape') return 'escape';
  if (e.ctrlKey || e.metaKey) return k === 'z' && !e.shiftKey ? 'undo' : null;
  if (e.shiftKey) return null;
  switch (k) {
    case 'b':
      return 'toggleBuild';
    case 's':
      return 'toggleShop';
    case 'm':
      return 'mergeAll';
    default:
      return null;
  }
}
